import { semanticColorsDarkTheme, semanticColorsLightTheme } from "./color";

export function applySemanticColorsToDocument(isDark: boolean): void {
  if (typeof document === "undefined") {
    return;
  }
  const palette = isDark ? semanticColorsDarkTheme : semanticColorsLightTheme;
  const root = document.documentElement;
  (Object.keys(palette) as Array<keyof typeof palette>).forEach((key) => {
    root.style.setProperty(`--${key}`, palette[key]);
  });
}
